import React from 'react';
import { ExternalLink, Settings, Clock } from 'lucide-react';

export default function As2TradingPartners() {
  const awsTransferFamilyUrl =
    'https://console.aws.amazon.com/transfer/home?region=us-east-1#/as2-trading-partners';

  return (
    <div className='flex items-center justify-center min-h-[60vh]'>
      <div className='text-center max-w-2xl mx-auto p-8'>
        {/* Coming Soon Icon */}
        <div className='mb-8'>
          <div className='w-24 h-24 mx-auto bg-blue-600/20 rounded-full flex items-center justify-center mb-4'>
            <Settings className='w-12 h-12 text-blue-400' />
          </div>
          <Clock className='w-8 h-8 text-yellow-400 mx-auto mb-4' />
        </div>

        {/* Coming Soon Text */}
        <h1 className='text-3xl font-bold text-white mb-4'>Coming Soon</h1>
        <p className='text-xl text-slate-300 mb-6'>
          AS2 Trading Partners management is being developed
        </p>
        <p className='text-slate-400 mb-8 leading-relaxed'>
          Advanced AS2 trading partner configuration and certificate management features are coming
          soon. For now, you can configure AS2 trading partners directly in the AWS Transfer Family
          console.
        </p>

        {/* AWS Transfer Family Link */}
        <div className='bg-slate-800/50 border border-slate-700 rounded-lg p-6 mb-8'>
          <h3 className='text-lg font-medium text-white mb-3'>
            Configure AS2 Trading Partners in AWS Console
          </h3>
          <p className='text-slate-400 mb-4'>
            Access the AWS Transfer Family console to set up AS2 trading partners, certificates, and
            secure file transfer configurations for your account.
          </p>
          <a
            href={awsTransferFamilyUrl}
            target='_blank'
            rel='noopener noreferrer'
            className='inline-flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors'
          >
            <ExternalLink className='w-4 h-4' />
            Open AWS Transfer Family Console
          </a>
        </div>

        {/* Features Preview */}
        <div className='text-left'>
          <h4 className='text-lg font-medium text-white mb-4'>Planned Features:</h4>
          <div className='grid md:grid-cols-2 gap-4 text-sm text-slate-400'>
            <div className='space-y-2'>
              <p>• AS2 trading partner management</p>
              <p>• Certificate upload and management</p>
              <p>• Encryption and signature configuration</p>
            </div>
            <div className='space-y-2'>
              <p>• MDN (Message Disposition Notification) setup</p>
              <p>• Transfer monitoring and logging</p>
              <p>• Partner status and health monitoring</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
